
import BookingExtraCheckboxList from "@/components/bookingflow/steps/extras/BookingExtraCheckboxList.vue";
import BookingExtraQuantityList from "@/components/bookingflow/steps/extras/BookingExtraQuantityList.vue";
import BookingExtraTermsCheckboxList from "@/components/bookingflow/steps/extras/BookingExtraTermsCheckboxList.vue";
import BaseAlert from "@/components/base/BaseAlert.vue";
import BookingExtraTermsCheckbox from "@/components/bookingflow/steps/extras/BookingExtraTermsCheckbox.vue";
import { DirectionEnum, TermTypeEnum, ModeOfTravelEnum, ExtraTypeEnum} from "@/models/enums";
import { ExtraInnerSection } from "@/models/www/ExtrasComponent"
import { defineComponent, PropType, computed } from "vue"
import { useBookingStore } from "@/store/booking";

export default defineComponent({
	components: {
		BookingExtraQuantityList,
		BookingExtraCheckboxList,
		BookingExtraTermsCheckboxList,
		BookingExtraTermsCheckbox,
		BaseAlert,
	},
	props: {
        componentIndex: Number,
		componentName: String,
        componentType: Number,
		innerSections: {
			type: Array as PropType<ExtraInnerSection[]>
		},
	},
	setup(props) {
        const isParking = props.componentType === ExtraTypeEnum.Parking;

		const resourcesInThisSection = props.innerSections?.flatMap((section) => section.resources).map((resource) => resource?.resourceCode) ?? [];		
		const bookingStore = useBookingStore();

		const getDirection = (section: ExtraInnerSection, index: number) => {
			
			if (bookingStore.booking.modeOfTravel === ModeOfTravelEnum.SailAndFly &&
					section.resources?.some((extra) => extra.resourceCode === "BUS")) {
					
					return DirectionEnum.Return;
			}
			else {
				//for skybus bus transfer outward/return to be added/removed correctly
				return index ? DirectionEnum.Return : DirectionEnum.Outward;
			}
		}		

		const ifExtraLuggage = computed(() => {
  		 	if (bookingStore
				.$state
				.booking
				.outward
				.resources
				.some((resource) => resourcesInThisSection.indexOf(resource.code) !== -1)) {
    			return true;
			} 
			else {
				return false;
			}  		
		});

		return { DirectionEnum, getDirection, ifExtraLuggage, TermTypeEnum, isParking }
	}
})
